import { getMenusList, getUserInfo } from "@/api/user";
import { useUser } from "@/store/user";
import RES_CODE from "@/util/code";
// import { getDataFromList } from '@/util/tree'
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/HomePage.vue"),
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "/index",
        component: () => import("../views/index/IndexHe.vue"),
      },
      {
        path: "/banner1/bannerList",
        component: () => import("../views/banner/bannerList.vue"),
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/LoginPage.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/index",
  },
];

function isTokenValid() {
  const token = localStorage.getItem("token");
  return token ? true : false;
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("跳转的路由地址1", to.fullPath);

  const userStore = useUser();

  if (to.path == "/login") {
    next();
  } else if (!isTokenValid) {
    next("/login");
  } else if (to.path !== "/login" && !isTokenValid()) {
    next("/login");
  } else if (userStore.menus.length == 0 && isTokenValid) {
    if (userStore.userInfo) {
      getMenusList().then((res) => {
        if (res.code == RES_CODE.SUCCESS) {
          // userStore.menus = getDataFromList(res.data)
          userStore.menus = res.data;
          userStore.menus.forEach((item) => {
            // router.addRoute(
            //   {
            //     path: '/' + item.route_name,
            //     component: () => import(`../views/${item.route_name}.vue`)
            //   }
            // router.addRoute(
            //   {
            //     path: '/' + item.route_name,
            //     component: () => import('../views/home/HomePage.vue'),
            //     children: item.children.map((sub) => ({
            //       path: '/' + item.route_name + '/' + sub.route_name,
            //       component: () => import(`../views/${item.route_name}/${sub.route_name}.vue`)
            //     }))
            //   }
            // )

            // )
            router.addRoute({
              path: "/" + item.route_name1,
              component: () => import("../views/home/HomePage.vue"),
              children: [
                {
                  path: "/" + item.route_name1 + "/" + item.route_name2,
                  component: () =>
                    import(
                      `../views/${item.route_name1}/${item.route_name2}.vue`
                    ),
                },
              ],
            });
          });
          console.log("跳转的路由地址2", to.fullPath);
          next(to.fullPath);
        } else {
          next("/login");
        }
      });
    } else {
      getUserInfo().then((res) => {
        if (res.code == RES_CODE.SUCCESS) {
          userStore.updateInfo(res.data);
          next(to.fullPath);
        } else {
          next("/login");
        }
      });
    }
  } else {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  }
});

export default router;
